import { colors } from './colors'

// MIGRATION: Tailwind synced with figma
export const shadows = {
	glow: `0 0.875rem 1.5rem -0.5625rem ${colors.brand[200]}33`,
	'gray-glow': `0 0.875rem 1.5rem -0.5625rem ${colors.black}33`
}
